import Model, { attr } from '@ember-data/model';

export default class CustomerCancellationModel extends Model {
  @attr('string') customerId!: string;
  @attr('string') hmac!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'customer-cancellation': CustomerCancellationModel;
  }
}
